export { ShortIdCompress } from './short-id-compress';
